const { useContext } = wp.element;
import { RouterContext, history } from "./context";
import classNames from "classnames";
import { match } from "path-to-regexp";
import { routes } from "../admin/settings/routes";

export function Link(props) {
  const { to, onClick, children, activeClassName } = props;
  const { route } = useContext(RouterContext);


  let state = { ...props };
  delete state.activeClassName;

  const isActive = () => {
    const checkMatch = match(`${to}`);
    return checkMatch(`${route.hash.substr(1)}`);
  };

  const handleClick = (e) => {
    e.preventDefault();

    // Trigger onClick prop manually even if the current path already matches.
    if (onClick) {
      onClick(e);
    }

    const { search } = history.location;

    if (!to.includes('settings')) {
      const newSearch = search.replace(/&tab=[^&]*/, '');
      history.push(`${newSearch}#${to}`);
    } else {
      history.push(`${search}#${to}`);
    }
  };

  return (
    <a
      {...state}
      className={classNames({ [activeClassName]: isActive() }, props.className)}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
